import { create } from "zustand";
import {
  getZohoData,
} from "../api";

export const useZohoData = create((set) => ({
  zohoData: {},
  zohoDataError: "",
  zohoDataLoading: false,
  fetchZohoData: async (pageNumber, startDate, endDate) => {
    set({zohoData:{}})
    try {
      set({ zohoDataLoading: true, error: null });
      const response = await getZohoData(
        `get-zoho-data`,
        pageNumber,
        startDate,
        endDate
      );
      set({ zohoData: response.data, zohoDataLoading: false });
    } catch (error) {
      set({ zohoDataError: error.message, zohoDataLoading: false });
    }
  },
}));

export const useCreditNoteData = create((set) => ({
  creditNoteData: {},
  creditNoteDataLoading: false,
  creditNoteDataError: "",
  fetchCreditNoteData: async (pageNumber, startDate, endDate) => {
    set({creditNoteData:{}})
    try {
      set({ creditNoteDataLoading: true, error: null });
      const response = await getZohoData(
        `get-credit-note-data`,
        pageNumber,
        startDate,
        endDate
      );
      set({ creditNoteData: response.data, creditNoteDataLoading: false });
    } catch (error) {
      set({ creditNoteDataError: error.message, creditNoteDataLoading: false });
    }
  },
}));

export const useErroredZohoInvoices = create((set) => ({
  erroredZohoInvoices: {},
  erroredZohoInvoicesError: "",
  erroredZohoInvoicesLoading: false,
  fetchErroredZohoInvoices: async (pageNumber, startDate, endDate) => {
    set({erroredZohoInvoices:{}})
    try {
      set({ erroredZohoInvoicesLoading: true, error: null });
      const response = await getZohoData(
        `get-errored-zoho-invoices`,
        pageNumber,
        startDate,
        endDate
      );
      set({
        erroredZohoInvoices: response.data,
        erroredZohoInvoicesLoading: false,
      });
    } catch (error) {
      set({
        erroredZohoInvoicesError: error.message,
        erroredZohoInvoicesLoading: false,
      });
    }
  },
}));

export const useErroredZohoCreditNotes = create((set) => ({
  erroredZohoCreditNotes: {},
  erroredZohoCreditNotesError: "",
  erroredZohoCreditNotesLoading: false,
  fetchErroredZohoCreditNotes: async (pageNumber, startDate, endDate) => {
    set({erroredZohoCreditNotes:{}})
    try {
      set({ erroredZohoCreditNotesLoading: true, error: null });
      const response = await getZohoData(
        `get-errored-zoho-credit-notes`,
        pageNumber,
        startDate,
        endDate
      );
      set({
        erroredZohoCreditNotes: response.data,
        erroredZohoCreditNotesLoading: false,
      });
    } catch (error) {
      set({
        erroredZohoCreditNotesLoading: error.message,
        erroredZohoCreditNotesLoading: false,
      });
    }
  },
}));
